import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductCollections } from '../../../models/product';

@Component({
  selector: 'header[app-main-header]',
  imports: [RouterModule],
  templateUrl: './main-header.html',
  styleUrl: './main-header.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainHeader {
  get bestSellersNo(): string {
    return ProductCollections.BestSellers;
  }

  get newArrivalsNo(): string {
    return ProductCollections.NewArrivals;
  }
}
